export default {
  name: "EmptyResultComponent",
  props: {
    title: {
      type: String,

      default() {
        return 'Не найдено';
      }

    },
    description: {
      type: String,

      default() {
        return '';
      }

    }
  }
};